<div  fxLayout="column">
  <h2 mat-dialog-title>{{ type | capitalize }} {{ resource }}</h2>
  <mat-dialog-content class="margin-bot" fxLayoutAlign="center center">Etes vous sur?</mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-flat-button mat-dialog-close class="button-flat black">Non</button>
    <button mat-flat-button (click)="confirm()" class="button-flat red">Oui</button>
  </mat-dialog-actions>
</div>
